import { render, staticRenderFns } from "./SubscriptionPromote.vue?vue&type=template&id=6bfca971"
import script from "./SubscriptionPromote.vue?vue&type=script&lang=js"
export * from "./SubscriptionPromote.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionPromote.vue?vue&type=style&index=0&id=6bfca971&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports